import React from "react";
import {Paper, Stack} from "@mui/material";

import {Controller, FormProvider, useForm} from "react-hook-form";

import {LoadingButton} from "@mui/lab";
import {MfaResetCodeFormInput} from "./MfaResetCodeFormInput";
import ResetMfaHint from "./ResetMfaHint";
import {AuthenticationHandler, useAuthenticate} from "../../useAuthenticate";
import {ResetMfaCredentials} from "../../types";
import ErrorBanner from "../../../../common/ErrorBanner";
import CancelMfaSignInButton from "../../../../common/CancelMfaSignInButton";
import {useLxTranslations} from "@lxo-blocks/react";
import {MFARESET_FORM_TRANSLATION} from "./MfaResetForm.translation.de";


export interface MfaResetFormProps {
    authenticationHandler: AuthenticationHandler,
    userId: string
}

export default function MfaResetForm(props: MfaResetFormProps) {
    const formMethods = useForm<ResetMfaCredentials>({
        mode: "all",
        defaultValues: {
            mfarecoverycode: ""
        }
    });
    const {t} = useLxTranslations(MFARESET_FORM_TRANSLATION);
    const {resetMfa, authenticationError} = useAuthenticate(props.authenticationHandler);
    const {handleSubmit, formState, control} = formMethods;
    const {isSubmitting, errors} = formState;

    const submitResetMfa = async (resetMfaCredentials: ResetMfaCredentials) => {
        resetMfaCredentials.userId = props.userId;
        return resetMfa(resetMfaCredentials);
    }

    return (
        <>
            <Paper sx={{px: 8, pt: 5, pb: 2}}>
                {authenticationError && (
                    <ErrorBanner headline={t("CREDENTIALS_LOGIN_MFA_RESET_FAILED")}
                                 description={authenticationError.description ? authenticationError.description : t("CREDENTIALS_LOGIN_MFA_RESET_FAILED_TRY_AGAIN")}
                                 sx={{mb: 3}}/>)}

                <FormProvider {...formMethods}>
                    <form onSubmit={handleSubmit(submitResetMfa)}>
                        <Controller
                            control={control}
                            name="mfarecoverycode"
                            rules={{required: t("MFA_RESET_CODE_REQUIRED").toString()}}
                            render={(props: any) => <MfaResetCodeFormInput {...props} sx={{mb: 3}}/>}/>

                        <ResetMfaHint sx={{mb: 3}}/>

                        <LoadingButton
                            sx={{pt: 1, pb: 1, mb: 1}}
                            variant="contained"
                            color="primary"
                            type="submit"
                            fullWidth
                            disabled={!!errors.mfarecoverycode}
                            loadingPosition="end"
                            endIcon={<></>}
                            loading={isSubmitting}
                        >{t("MFA_RESET_SUBMIT")}
                        </LoadingButton>
                    </form>
                </FormProvider>

            </Paper>

            <Stack spacing={2} direction="row-reverse" style={{float: "right"}} mt={1}>
                <CancelMfaSignInButton/>
            </Stack>
        </>
    );
}